/* HAPPY LITTLE PAWS — Smart Cross-Sell Drawer Carousel V3 — JS FIX 2026-10-11
   - Reuses up to 12 configured offers from the Cart Page's inert <template>.
   - Swipeable horizontal carousel + accessible back/forward controls.
   - Direct add-to-cart, Dawn pub/sub, no edits to cart.js/cart-drawer.js.
   - The old preview V2 script must NOT be loaded alongside this file.
*/
(() => {
  'use strict';
  if (window.__hlpScsDrawerCarouselV3) return;
  window.__hlpScsDrawerCarouselV3 = true;

  const rootPath = window.Shopify?.routes?.root || '/';
  const cartUrl = `${rootPath}cart`;
  const targetSelector = '#CartDrawer #hlp-scs-drawer-mount';
  const drawer = () => document.querySelector('cart-drawer');
  const mount = () => document.querySelector(targetSelector);
  const drawerOpen = () => drawer()?.classList.contains('active') === true;
  const de = () => document.documentElement.lang?.toLowerCase().startsWith('de');

  let requestVersion = 0;
  let refreshTimer;
  let prevMount = null;
  let wasOpen = false;
  let adding = false;

  const errorMessage = (message) => {
    const target = mount();
    if (!target) return;
    let node = target.querySelector('[data-hlp-scs-error]');
    if (!node) {
      node = document.createElement('p');
      node.className = 'hlp-scs__drawer-error';
      node.dataset.hlpScsError = '';
      node.setAttribute('role', 'alert');
      target.appendChild(node);
    }
    node.textContent = message;
  };

  function fixIds(panel) {
    const idMap = new Map();
    panel.querySelectorAll('[id]').forEach((node) => {
      const oldId = node.id;
      const newId = `hlp-scs-drawer-v3-${oldId}`;
      idMap.set(oldId, newId);
      node.id = newId;
    });
    panel.querySelectorAll('[for], [aria-labelledby], [aria-describedby]').forEach((node) => {
      ['for', 'aria-labelledby', 'aria-describedby'].forEach((attr) => {
        const value = node.getAttribute(attr);
        if (!value) return;
        node.setAttribute(attr, value.split(/\s+/).map((id) => idMap.get(id) || id).join(' '));
      });
    });
  }

  function makeNavButton(direction) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'hlp-scs__carousel-arrow';
    button.setAttribute('data-hlp-scs-move', String(direction));
    button.textContent = direction < 0 ? '‹' : '›';
    button.setAttribute('aria-label', direction < 0
      ? (de() ? 'Vorherige Empfehlungen' : 'Previous suggestions')
      : (de() ? 'Nächste Empfehlungen' : 'Next suggestions'));
    return button;
  }

  function updateArrows(target) {
    const track = target.querySelector('.hlp-scs__cards--carousel');
    const nav = target.querySelector('.hlp-scs__carousel-nav');
    if (!track || !nav) return;
    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    nav.hidden = maxScroll < 5;
    const prev = nav.querySelector('[data-hlp-scs-move="-1"]');
    const next = nav.querySelector('[data-hlp-scs-move="1"]');
    if (prev) prev.disabled = track.scrollLeft <= 3;
    if (next) next.disabled = track.scrollLeft >= maxScroll - 3;
  }

  function decorate(panel, target) {
    fixIds(panel);
    panel.classList.add('hlp-scs__panel--drawer');
    const track = panel.querySelector('.hlp-scs__cards');
    const heading = panel.querySelector('.hlp-scs__heading-group');
    if (!track || !heading) return false;

    track.classList.add('hlp-scs__cards--carousel');
    track.id = 'hlp-scs-drawer-v3-track';
    track.setAttribute('aria-label', de() ? 'Passende Produkte' : 'Suggested products');
    track.setAttribute('tabindex', '0');

    const top = document.createElement('div');
    top.className = 'hlp-scs__carousel-top';
    heading.parentNode.insertBefore(top, heading);
    top.appendChild(heading);
    const nav = document.createElement('div');
    nav.className = 'hlp-scs__carousel-nav';
    nav.appendChild(makeNavButton(-1));
    nav.appendChild(makeNavButton(1));
    nav.querySelectorAll('button').forEach((button) => {
      button.setAttribute('aria-controls', track.id);
    });
    top.appendChild(nav);

    // Horizontal scrolling works natively with mouse, touch and keyboard.
    track.addEventListener('scroll', () => updateArrows(target), { passive: true });
    requestAnimationFrame(() => updateArrows(target));
    return true;
  }

  async function refresh() {
    const target = mount();
    if (!target || !drawerOpen() || adding) return;
    const version = ++requestVersion;
    try {
      const response = await fetch(cartUrl, {
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const template = doc.querySelector('#MainContent [data-hlp-scs-drawer-source]');
      if (version !== requestVersion || !target.isConnected || !drawerOpen()) return;
      if (!template?.content) {
        target.replaceChildren();
        target.hidden = true;
        return;
      }
      const panel = template.content.querySelector('.hlp-scs__panel')?.cloneNode(true);
      if (!panel || !panel.querySelector('.hlp-scs__card')) {
        target.replaceChildren();
        target.hidden = true;
        return;
      }
      target.replaceChildren(panel);
      target.hidden = false;
      decorate(panel, target);
    } catch (error) {
      console.warn('[HLP SCS Drawer Carousel V3] Could not load offers:', error);
      // Recommendation failure must never block cart checkout.
    }
  }

  function scheduleRefresh(delay = 170) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, delay);
  }

  function refreshBubble(sectionHtml) {
    if (!sectionHtml) return;
    const current = document.querySelector('#cart-icon-bubble');
    if (!current) return;
    const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const fresh = doc.querySelector('#cart-icon-bubble') ||
      doc.querySelector('#shopify-section-cart-icon-bubble') ||
      doc.querySelector('.shopify-section');
    if (fresh) current.innerHTML = fresh.innerHTML;
  }

  function publishCart(cart, variantId) {
    const pubEvents = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;
    const send = typeof publish === 'function' ? publish : window.publish;
    if (pubEvents?.cartUpdate && typeof send === 'function') {
      send(pubEvents.cartUpdate, {
        source: 'hlp-scs-drawer-v3',
        cartData: cart,
        variantId
      });
    } else {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      if (typeof drawer()?.refreshFromServer === 'function') drawer().refreshFromServer();
    }
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const arrow = event.target.closest(`${targetSelector} [data-hlp-scs-move]`);
    if (!arrow) return;
    const track = mount()?.querySelector('.hlp-scs__cards--carousel');
    const card = track?.querySelector('.hlp-scs__card');
    if (!track || !card) return;
    const gap = parseFloat(getComputedStyle(track).gap) || 0;
    track.scrollBy({ left: Number(arrow.dataset.hlpScsMove) * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
  });

  // Capture this specific select change BEFORE Dawn's cart-drawer-items
  // treats it as a quantity input change (which causes the "undefined" step error).
  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element)) return;
    const select = event.target.closest(`${targetSelector} [data-hlp-scs-variant]`);
    if (!select) return;
    event.stopPropagation();
    const card = select.closest('.hlp-scs__card');
    const button = card?.querySelector('[data-hlp-scs-add]');
    if (button) button.disabled = !select.value;
    const price = card?.querySelector('[data-hlp-scs-price]');
    const chosen = select.selectedOptions?.[0];
    if (price && chosen?.dataset.price) price.textContent = chosen.dataset.price;
  }, true);

  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest(`${targetSelector} [data-hlp-scs-add]`);
    if (!button || button.disabled || adding) return;
    const card = button.closest('.hlp-scs__card');
    const select = card?.querySelector('[data-hlp-scs-variant]');
    const variantId = select ? select.value : button.dataset.variantId;
    if (!variantId) return;

    adding = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const originalContent = button.innerHTML;
    try {
      const response = await fetch(`${rootPath}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: ['cart-icon-bubble'],
          sections_url: cartUrl
        })
      });
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.description || data.message || `HTTP ${response.status}`);
      }
      const result = await response.json();
      refreshBubble(result.sections?.['cart-icon-bubble']);
      const cartResponse = await fetch(`${rootPath}cart.js`, {
        credentials: 'same-origin', cache: 'no-store'
      });
      if (!cartResponse.ok) throw new Error(`Cart HTTP ${cartResponse.status}`);
      publishCart(await cartResponse.json(), variantId);
      // No success banner; updated cart is the confirmation.
    } catch (error) {
      console.error('[HLP SCS Drawer Carousel V3] Add failed:', error);
      errorMessage((de() ? 'Hinzufügen fehlgeschlagen: ' : 'Could not add: ') + error.message);
    } finally {
      if (button.isConnected) {
        button.removeAttribute('aria-busy');
        button.innerHTML = originalContent;
      }
      adding = false;
      scheduleRefresh(450);
    }
  });

  function boot() {
    const cartDrawer = drawer();
    if (!cartDrawer) return;
    prevMount = mount();
    wasOpen = drawerOpen();

    const observer = new MutationObserver(() => {
      const nextMount = mount();
      const nowOpen = drawerOpen();
      if (nowOpen && (!wasOpen || nextMount !== prevMount)) scheduleRefresh(130);
      prevMount = nextMount;
      wasOpen = nowOpen;
    });
    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });

    function onCartUpdate() {
      if (drawerOpen()) scheduleRefresh(260);
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    } else if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    }
    document.addEventListener('cart:updated', onCartUpdate);
    window.addEventListener('pageshow', (event) => {
      if (event.persisted && drawerOpen()) scheduleRefresh(0);
    });
    if (wasOpen) scheduleRefresh(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
